import block from 'bem-cn';
import Avatar, { TAvatar } from '../Avatar/Avatar';
import './AvatarList.scss';

const b = block('AvatarList');

type Props = {
  avatars: TAvatar[];
}

const AvatarList = ({ avatars }: Props) => {

  return (
    <ul className={b()}>
      {avatars.map(({ image, isOnline }, index) => (
        <li key={index} className={b('avatar')}>
          <Avatar image={image} isOnline={isOnline} />
        </li>
      ))}
    </ul>
  );
}

export default AvatarList;